/* unplugin-vue-components disabled */import script from "./RestoreLogs.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestoreLogs.vue?vue&type=script&lang=ts&setup=true"

import "./RestoreLogs.vue?vue&type=style&index=0&id=36598d4a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36598d4a"]])

export default __exports__